import * as yup from "yup";

export const validationSchema = yup.object({
  adId: yup.string().trim().required("Ad Id is Required"),
  cfStatus: yup.string().trim().required("CF Status is Required"),
  utmParameter: yup.string().trim().required("Utm Parameter is Required"),
  creativeId: yup.string().trim().required("Creative Id is Required"),
  leadId: yup.string().required("Lead Id is Required"),
});
